import React, { useState } from 'react';
import {
  Row,
  Col,
  DatePicker,
  Typography,
  Checkbox,
  Skeleton,
  Result
} from 'antd'
// import {
//   SearchOutlined
// } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import SalesCard from './components/SalesCard';
import { useQuery } from '@tanstack/react-query';
// import DashboardPiechart from './components/DashboardPiechart';
import DashboardBarchart from './components/DashboardBarchart';
import DashboardInventory from './components/DashboardInventory';
import ReportPanel from './components/ReportPanel';

const cardDatas = [
  {
    key: 'orders',
    label: 'คำสั่งซื้อ',
    value: 459,
    unit: 'pcs',
    cardBg: '#E3EFFF',
    labelColor: '#000',
    valueColor: '#1A6EE1',
    iconBg: '#1A6EE1',
    iconColor: '#FFF',
  },
  {
    key: 'received',
    label: 'รับสินค้า',
    value: 459,
    unit: 'pcs',
    cardBg: '#fff9e0',
    labelColor: '#000',
    valueColor: '#ffce44',
    iconBg: '#ffce44',
    iconColor: '#fff',
  },
  {
    key: 'transfer',
    label: 'โอนสินค้า',
    value: 459,
    unit: 'pcs',
    cardBg: '#EEE5FF',
    labelColor: '#000',
    valueColor: '#752FDD',
    iconBg: '#752FDD',
    iconColor: '#fff',
  },
  {
    key: 'revenue',
    label: 'ยอดขาย',
    value: 459,
    unit: 'pcs',
    cardBg: '#D9FFF6',
    labelColor: '#000',
    valueColor: '#3BC3A3',
    iconBg: '#3BC3A3',
    iconColor: '#fff',
  }
]
function Dashboard() {

  const [isShowInventory, setIsShowInventory] = useState(false);
  const redirect = useNavigate();
  const location = useLocation();
  const startDate = new URLSearchParams(location.search).get('start_date');
  const endDate = new URLSearchParams(location.search).get('end_date');

  const { isError, isLoading, data, error } = useQuery({
    queryKey: [`/api/report/getDashboardData?start_date=${startDate}&end_date=${endDate}`],
  })
  const transactionReportQuery = useQuery({
    queryKey: [`/api/report/getTransactionReport?start_date=${startDate}&end_date=${endDate}`],
  })
  const inventoryReportQuery = useQuery({
    queryKey: [`/api/report/getInventory`],
  })

  const onChange = (value, dateString) => {

    redirect(`/admin/dashboard?start_date=${dayjs(value[0]).toISOString()}&end_date=${dayjs(value[1]).toISOString()}`)

  }


  if (isLoading || transactionReportQuery.isLoading || inventoryReportQuery.isLoading) {
    return <Skeleton active />
  }

  if (isError || transactionReportQuery.isError || inventoryReportQuery.isError) {
    return <Result status="error" title={error.message || transactionReportQuery.error.message || inventoryReportQuery.error.message} />
  };

  const onShowInventory = (e) => {
    setIsShowInventory(e.target.checked);
  }
  // console.log('startDate = ', startDate)
  // console.log('endDate = ', endDate)
  // console.log('data = ', data)
  // console.log('openCalendar = ', openCalendar)
  // console.log('transactionReportQuery.data = ', transactionReportQuery.data)
  // console.log('inventoryReportQuery.data = ', inventoryReportQuery.data)

  return (
    <div>
      <Row justify="end" style={{ marginBottom: '16px' }}>
        <Col>
          <Typography.Title level={3} style={{ margin: 0, padding: 0, color: '#2F17E7' }}>
            {dayjs().format('DD-MM-YYYY')}
          </Typography.Title>
        </Col>
      </Row>
      <Row style={{ marginBottom: '16px' }} gutter={[16, 16]}>
        <Col>
          <div className='dashboard-rangepicker-container'>
            <DatePicker.RangePicker
              defaultValue={[dayjs(startDate), dayjs(endDate)]}
              format={'DD-MM-YYYY'}
              allowClear={false}
              onChange={onChange}
              style={{
                borderColor: '#1a6ee1'
              }}
            />
          </div>
        </Col>
        <Col>
          <Checkbox onChange={onShowInventory}>แสดงรายการสินค้าคงคลัง</Checkbox>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]} style={{ marginBottom: '32px' }}>
        {
          cardDatas.map(item =>
            <Col xs={24} sm={12} md={6} key={item.key}>
              <SalesCard cardTemplate={item} cardData={data} />
            </Col>
          )
        }
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col xs={24}>
          <DashboardBarchart barData={data.weekly_order} />
        </Col>
        {isShowInventory && <Col xs={24}>
          <DashboardInventory
            products={inventoryReportQuery.data.products}
            productQuantity={inventoryReportQuery.data.total}
            productPrice={inventoryReportQuery.data.price}
          />
        </Col>}
        <Col xs={24}>
          <ReportPanel transactionReportQuery={transactionReportQuery} />
        </Col>
        {/* <Col xs={24}>
          <DashboardOrder
            orders={transactionReportQuery.data.order_items}
            quantity={transactionReportQuery.data.order_quantity}
            revenue={transactionReportQuery.data.order_total_price}
          />
        </Col> */}
        {/* <Col xs={24}>
          <DashboardReceived
            receivedItems={transactionReportQuery.data.received_items}
            quantity={transactionReportQuery.data.received_quantity}
            price={transactionReportQuery.data.received_price}
          />
        </Col> */}
        {/* <Col xs={24}>
          <DashboardTransfer
            transferedItems={transactionReportQuery.data.transfer_items}
            quantity={transactionReportQuery.data.transfer_quantity}
            price={transactionReportQuery.data.transfer_price}
          />
        </Col> */}

        {/* <Col xs={24} md={12}>
          <DashboardPiechart />
        </Col> */}
      </Row>
    </div>
  )
}

export default Dashboard